import React from 'react'
import SchoolDashbaord from '../../features/school/SchoolDashbaord'

const SchoolDashbaordPage = () => {
    return (
        <SchoolDashbaord />
    )
}

export default SchoolDashbaordPage
